import React, { Component } from 'react';


class Header extends Component {
  render() {
     //<ParticlesBg type="circle" bg={true} />

    if(this.props.data){
      var profilepic= "images/"+this.props.data.image;
       var project = this.props.data.project;
       var github = this.props.data.github;
      var name = this.props.data.name;
      var description= this.props.data.description;
      var description2= this.props.data.description2;
      var city= this.props.data.address.city;
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
      })
    }
//<img src="images/cecile.jpg"></img>
/*
<ul className="social">
               <a href={project} className="button btn project-btn"><i className="fa fa-book"></i>Project</a>
               <a href={github} className="button btn github-btn"><i className="fa fa-github"></i>Github</a>
            </ul>*/
    return (
      <header id="home">
      
      <nav id="nav-wrap">
         <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
	      <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

         <ul id="nav" className="nav">
            <li className="current"><a className="smoothscroll" href="#home">Accueil</a></li>
	         <li><a className="smoothscroll" href="#resume">Prestations</a></li>
            <li><a className="smoothscroll" href="#portfolio">Tarifs</a></li>
            <li><a className="smoothscroll" href="#about">A propos</a></li>
            {//<li><a className="smoothscroll" href="#contact">Contact</a></li>
  }
         </ul>
      </nav>

      <div className="row banner">
      
         <div className="banner-text">
            <h1 className="responsive-headline alex">{name}</h1>
            <h3>{description}</h3>
            <h3>{description2}</h3>
                       
         </div>         
      </div>

      <p className="scrolldown">
         <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
      </p>

   </header>
    );
  }
}

export default Header;
